import { Subject } from "rxjs";

import setting from "../store/modules/app";
import log2 from "./log2";
import socketStatus from "../store/modules/socketStatus";
import { publishMessage } from "./systemPubSub";

const messages = new Subject();
const log = log2("SocketStream");

export const addMessage = (cmd, data) =>
    messages.next({
        cmd,
        data,
    });

export const sendSocketMessage = (type, payload) => {
    if (!["pong"].includes(type)) {
        log("send socket message", type, payload);
    }

    const socket = socketStatus.state.current_socket;

    if (socket === null) return false;
    if (!setting.state.multiSessionMode) {
        socket.emit(type, payload);
        return true;
    } else {
        log.warn("***Cannot send Message to socket in multi session mode ");
    }
    return false;
};

export const socketMessageStream = messages.asObservable();
